import React, { useEffect } from "react";
import { Button, Modal, Form, Input, message } from "antd";
import API from "../../../../services/api-request";

const EditWarehouse = (props) => {
  const [editForm] = Form.useForm();

  const onFinish = async (values) => {
    const { name } = values;

    const dataForm = {
      name,
    };

    await API.Put(`warehouse/${props.selectedData.id}`, dataForm)
      .then(() => {
        message.success("Warehouse has been edited");
        props.onGetWarehouse();
        editForm.resetFields();
        props.onShowEdit(false);
      })
      .catch((err) => {
        console.log(err);
        message.info(`${err?.response?.data?.error}`);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowEdit(false);
    editForm.resetFields();
  };

  useEffect(() => {
    editForm.setFieldsValue(props.selectedData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedData]);

  useEffect(() => {
    if (!props.showEdit) {
      editForm.resetFields();
    }
  }, [props.showEdit]);

  return (
    <>
      <Modal
        title="Edit Warehouse"
        open={props.showEdit}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => editForm.submit()}>
            Save
          </Button>,
        ]}
      >
        <Form
          form={editForm}
          name="Edit Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Please input name!" }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default EditWarehouse;
